import React from 'react';
import { useIntl } from 'react-intl';
import { Surface, Logo } from '@americanexpress/dls-react';
const Header = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(Surface, {
    variant: "foreground",
    className: "nav nav-header pad-2 shadow-1 dls-deep-blue-bg flex flex-column flex-align-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-align-center"
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: "line",
    color: "white",
    size: "sm",
    alt: formatMessage({
      id: 'americanExpress'
    })
  }), /*#__PURE__*/React.createElement("span", {
    className: "dls-white heading-5"
  }, '\u00AE')), /*#__PURE__*/React.createElement("span", {
    className: "heading-sans-small-regular dls-light-blue margin-1-t"
  }, formatMessage({
    id: 'invoiceManagement'
  })));
};
export const TestableHeader = Header;
export default Header;